import type { EClickType } from '@gem-sdk/heatmap-react';

import { useHeatmapAnalyticDeviceType } from './useHeatmapAnalyticDeviceType';
import { EHeatmapClickType, MAP_CLICK_TYPE_TO_KEY } from '../types';
import { useMemo } from 'react';

interface IClickTypeCounts {
  getCountByClickType: (clickType: EClickType) => number;
}

export const useHeatmapAnalyticClickType = (): IClickTypeCounts => {
  const { data: deviceData } = useHeatmapAnalyticDeviceType();

  const clickTypeTotals = useMemo(() => {
    if (!deviceData?.clickTypes) return {};

    const totals: Partial<Record<EHeatmapClickType, number>> = {};

    for (const ct of deviceData.clickTypes) {
      totals[ct.type] = (totals[ct.type] ?? 0) + ct.totalCount;
    }

    // Add total clicks for all click types
    totals[EHeatmapClickType.ALL] = deviceData.totalClicks;

    return totals;
  }, [deviceData]);

  const getCountByClickType = (clickType: EClickType): number => {
    return clickTypeTotals[MAP_CLICK_TYPE_TO_KEY[clickType]] ?? 0;
  };

  return { getCountByClickType };
};
